import OBTOSubDocument from './obto-component-subdocument';
import OBTODocument from './obto-component-document';
import OBTOMonacoEditor from './obto-component-monaco-editor';
import OBTODifferenceChecker from './obto-component-difference-checker';
import './obto-data-service';
import './angular-documentHelper';

export default angular.module('obto.components', ['document.helper', 'obto.data.service'])
    .component(OBTOSubDocument.selector, OBTOSubDocument)
    .component(OBTODocument.selector, OBTODocument)
    .component(OBTODifferenceChecker.selector, OBTODifferenceChecker)
    .component(OBTOMonacoEditor.selector, OBTOMonacoEditor);
